import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ZonePage from "@/pages/ZonePage";
import ServicePage from "@/pages/ServicePage";
import InsuranceAccidentPage from "@/pages/InsuranceAccidentPage";
import BeachRecoveryPage from "@/pages/BeachRecoveryPage";
import NotFound from "@/pages/NotFound";
import { getZone } from "@/lib/zones";
import { getService } from "@/lib/services";

const CUSTOM_SLUGS = {
  "carro-attrezzi-incidente-assicurazione-roma": InsuranceAccidentPage,
  "recupero-auto-spiaggia-ostia-fregene-terracina": BeachRecoveryPage,
};

/**
 * Single dynamic route that dispatches to ZonePage / ServicePage / custom
 * standalone SEO pages based on slug, or renders NotFound if unknown.
 */
export default function SlugRouter() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/" replace />;
  const Custom = CUSTOM_SLUGS[slug];
  if (Custom) return <Custom />;
  if (getZone(slug)) return <ZonePage />;
  if (getService(slug)) return <ServicePage />;
  return <NotFound />;
}
